import { render, staticRenderFns } from "./Header.vue?vue&type=template&id=420fa43f&lang=pug"
import script from "./Header.vue?vue&type=script&lang=js"
export * from "./Header.vue?vue&type=script&lang=js"
import style0 from "./Header.vue?vue&type=style&index=0&id=420fa43f&prod&lang=scss"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {AutosaveStatus: require('/home/docker/code/frontend/components/AutosaveStatus.vue').default,Name: require('/home/docker/code/frontend/components/Name.vue').default,Icon: require('/home/docker/code/frontend/components/Icon.vue').default,SurveyQuickEditForm: require('/home/docker/code/frontend/components/SurveyQuickEditForm.vue').default,RelatedClientSelect: require('/home/docker/code/frontend/components/RelatedClientSelect.vue').default,ClientAgentName: require('/home/docker/code/frontend/components/ClientAgentName.vue').default,MatchingClientsAlert: require('/home/docker/code/frontend/components/MatchingClientsAlert.vue').default,EdgeToggle: require('/home/docker/code/frontend/components/EdgeToggle.vue').default})
